<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading
        :active.sync="loaderPDF"
        :can-cancel="false"
        :is-full-page="true"
    ></loading>
    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Consulta Historica PTI</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>CÓDIGO: Consultar_his_PTI</div>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col>
          <b-table-simple>
            <BandejaFiltros :fields="fields" @fieldsTable="obtener"></BandejaFiltros>
            <!--<b-thead>
              <b-tr>
                <b-th class="align-middle" v-for="(field, index) in fields" :key="index" :style="index === 1 ? 'width: 12rem;':''">
                  <span v-if="index !== 1 && index !== 2 && index !== 3">{{ field.label }}</span>
                    <date-picker :lang="idiomaCalendario" size="sm" v-if="field.filtro && index === 2"
                        v-model="fechaInicio" range value-type="format" :editable="false" placeholder="Fecha solicitud" :disabled-date="bloquearDiasDespuesDeHoy" @input="obtener(1,index)">
                    </date-picker>
                    <date-picker :lang="idiomaCalendario" size="sm" v-if="field.filtro && index === 3"
                                 v-model="fechaInicioPti" range value-type="format" :editable="false" placeholder="Fecha aceptación" :disabled-date="bloquearDiasDespuesDeHoy" @input="obtener(2,index)">
                    </date-picker>
                  <div v-if="field.filtro && index === 1" class="custom" ref="customSelect">
                    <div class="select-header text-center" @click="toggleOptions">
                      {{ selected.text || 'Todas las solicitudes' }}
                      <span class="arrow-down"></span>
                    </div>
                    <ul class="select-options text-center" v-show="showOptions">
                      <li v-for="option in options" :key="option" @click="selectOption(option)">{{ option.text }}</li>
                    </ul>
                  </div>
                </b-th>
              </b-tr>
            </b-thead>-->
            <b-tbody>
              <b-tr v-for="(dato, index) in datosTabla" :key="index">
                <b-td>{{ dato.idPti }}</b-td>
                <b-td>{{ dato.nombreClasificacion }}</b-td>
                <b-td>{{ dato.fechaAlta | formatoFechaHora }}</b-td>
                <b-td>{{ dato.fechaAceptacionPti}}</b-td>
                <b-td>{{ dato.nombreClinica }}</b-td>
                <b-td>{{ dato.registroActivo ? dato.estatusEtapa : 'Inactivo' }}</b-td>
                <b-td>
                  <b-button
                      title="Descargar PDF"
                      size="sm"
                      v-if="dato.registroActivo && $localStorageService.can('PR_01_consultar_imp_pti')"
                      variant="outline-primary"
                      :disabled="loaderPDF"
                      @click="descargarAchivo(dato)">
                    <em
                        v-if="!loaderPDF"
                        class="fa fa-download">
                    </em>
                    <b-spinner small v-else label="Spinning"></b-spinner>
                  </b-button>
                  <b-button
                      v-if="!dato.registroActivo"
                      id="popover-boton-info"
                      style="box-shadow: rgb(0 0 0 / 25%) 0px 3px 4px 0px"
                      variant="light"
                      class="rounded-circle mb-1 paddingbotones"
                      v-b-tooltip.hover.auto:title="'No se ha encontrado el PTI'"
                  >
                    <em class="i_info_svg sm"></em>
                  </b-button>
                  <b-button
                      title="Enviar correo"
                      size="sm"
                      @click="enviarCorreo(dato)"
                      v-if="dato.registroActivo && $localStorageService.can('PR_01_consultar_correo_PTI')"
                      lazy
                      variant="outline-warning"
                      :disabled="loaderPDF"
                  ><b-icon icon="envelope-fill"></b-icon>
                  </b-button>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
        </b-col>
      </b-row>
      <b-col v-if="!loader">
        <b-pagination
            v-if="datosTabla !== undefined && datosTabla.length > 10"
            align="center"
            v-model="paginaActualVersionesPTI"
            :total-rows="datosTabla.length"
            :per-page="registrosPorPaginaVersionesPTI"
            aria-controls="my-table1"
        ></b-pagination>
        <div v-if="!loader" class="w-50" style="  float: right; margin-right: 8%;">
          <b-alert  class="w-50" v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
        </div>
      </b-col>
    </b-container>

    <b-modal v-model="mostrarDescarga" title="Descargar PDF" size="lg" no-close-on-backdrop>
      <b-container fluid>
        <b-row>
          <b-col>
            <div id="loadImg" class="text-center">
              <b-spinner small variant="primary" label="Spinning"></b-spinner>
            </div>
            <iframe
                :src="'data:application/pdf;base64,' + base64Archivo"
                width="100%"
                height="600"
                onload="document.getElementById('loadImg').style.display='none';"
                style="height: 77vh"
            ></iframe>
          </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer">
        <b-button variant="outline-danger" @click="cerrarModalPrevia()"
        >Cancelar</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import {validationMixin} from "vuelidate";
import BandejaFiltros from "@/components/BandejaFiltros/BandejaFiltros";
import {AwsService} from "../../apiServices/aws/AwsService";
import { S3Client, GetObjectCommand, S3ServiceException, NoSuchKey } from "@aws-sdk/client-s3"
import moment from "moment";

export default {
  name: "VersionesPTI",
  components: {
    BandejaFiltros
  },
  props: {
    propidPaciente: Number
  },
  mixins: [validationMixin],
  data: () =>{
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      awsServicio: new AwsService(),
      token: null,

      idPti: 0,
      idFotoPti: 0,
      idPaciente: 0,
      loader : false,
      datosTabla: [],
      fields: [
        {key: "idPti", label: "ID PTI", sortable: true, filtro: false,  tipoFiltro: '', options: [],  valor: null},
        {key: "nombreClasificacion", label: "Tipo de solicitud", sortable: true, filtro: true,  tipoFiltro: 'select',options: [
            { value: 0, text: 'Todas las solicitudes' },
            { value: 13, text: 'Replica' },
            { value: 12, text: 'M2' },
            { value: 14, text: 'Edición Pti' }
          ], valor: { value: 0, text: 'Todas las solicitudes' }},
        {key: "fechaAlta", label: "Fecha de Solicitud", sortable: true, filtro: true, tipoFiltro: 'fecha',options: [], valor: null},
        {key: "fechaAceptacionPti", label: "Fecha de aceptación PTI", sortable: true, filtro: true,  tipoFiltro: 'fecha',options: [], valor: null},
        {key: "nombreClinica", label: "Clínica", sortable: true, filtro: false,  tipoFiltro: '',options: [], valor: null},
        {key: "estatusEtapa", label: "Estatus", sortable: true, filtro: false,  tipoFiltro: '',options: [], valor: null},
        { label: "Acciones", sortable: false, filtro: false,  tipoFiltro: '',options: [], valor: null},
      ],
      paginaActual: 1,
      tituloModal: '',
      loaderAcciones: false,
      mostrarDescarga: false,
      base64Archivo: "",
      loaderPDF: false,
      registrosPorPaginaVersionesPTI:10,
      paginaActualVersionesPTI: 1,

      modalFiltros: false,
      indexFiltro: null,
      tipoHorario: 0,
      tipoFiltro: 0,

      filtroText: "",
      nombrePacienteFiltro: "",
      nombreDoctorFiltro: "",
      tipoTags: [],
      tipoFlujoFiltro: null,
      numeroSillonFiltro: 0,
      horaInicioFiltro: [],
      horaFinFiltro: [],
      mostrarBotones: true,
      filtros:{
        "idPaciente": null,
        "tipoFiltroClasifacion": 0,
        "idClasificacionSolicitud": 0,
        "fechaInicio": null,
        "fechaFin": null,
        "tipoFechaSolicutud":0,
        "tipoFechaAceptacion":0
      },
      selected: 0,
      options: [
        { value: 0, text: 'Todas las solicitudes' },
        { value: 13, text: 'Replica' },
        { value: 12, text: 'M2' },
        { value: 14, text: 'Edición Pti' },
      ],
      showOptions: false,
      fechaInicio: null,
      fechaFin: null,
      fechaInicioPti: null,
      fechaFinPti: null,
      idiomaCalendario: {
        formatLocale: {
          // MMMM
          months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
          // MMM
          monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
          // dd
          weekdaysMin: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
        },
        monthFormat: 'MMMM',
      }
    }
  },
  async created() {
    this.debug = this.$localStorageService.getDebug();
    this.token = this.$localStorageService.getTokenAWSPti();
    await this.validarTokenAWS();

    this.filtros.idPaciente = this.propidPaciente;

    this.obtener(null,0);
  },
  mounted() {
    window.addEventListener('click', this.handleClickOutside);
  },
  computed: {
    fields() {
      return this.fields;
    }
  },
  methods: {
    async validarTokenAWS() {
      if (this.token !== null) {
        if (this.token.expireTo < moment(new Date()).format("YYYY-MM-DD HH:mm:ss")) {
          await this.awsServicio.obtenerTokenAccesoPti().then((response) => {
            this.token = response.data
            this.$localStorageService.setTokenAWSPti(this.token)
          })
        }else{
          if(typeof this.token === 'string'){
            this.token = JSON.parse(this.token);
          }
        }
      } else {
        await this.awsServicio.obtenerTokenAccesoPti().then((response) => {
          this.token = response.data
          this.$localStorageService.setTokenAWSPti(this.token)
        })
      }
    },
    obtener(fields, index){
      if(fields != null) {
        this.fields = fields;
        if (this.fields[1].valor.value === 0) {
          this.filtros.tipoFiltroClasifacion = 0;
          this.filtros.idClasificacionSolicitud = 0;
        } else {
          this.filtros.tipoFiltroClasifacion = 1;
          this.filtros.idClasificacionSolicitud = this.fields[1].valor.value;
        }
        if (this.fields[2].tipoFiltro === 'fecha' && this.fields[2].valor !== null && index === 2) {
          if (this.fields[2].valor[0] !== null) {
            this.filtros.tipoFechaSolicutud = 1;
            this.filtros.fechaInicio = this.$moment(this.fields[2].valor[0]).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");
            this.filtros.fechaFin = this.$moment(this.fields[2].valor[1]).utc().format("YYYY-MM-DD[T]23:59:59[Z]");
            this.fields[3].valor = null;
          } else {
            this.filtros.tipoFechaSolicutud = 0;
            this.filtros.fechaInicio = null;
            this.filtros.fechaFin = null;
          }
          // this.filtros.tipoFiltroClasifacion = 0;
        }
        if (this.fields[3].tipoFiltro === 'fecha' && this.fields[3].valor !== null && index === 3) {
          if (this.fields[3].valor[0] !== null) {
            this.filtros.tipoFechaSolicutud = 0;
            this.filtros.tipoFechaAceptacion = 1;
            this.filtros.fechaInicio = this.$moment(this.fields[3].valor[0]).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");
            this.filtros.fechaFin = this.$moment(this.fields[3].valor[1]).utc().format("YYYY-MM-DD[T]23:59:59[Z]");
          } else {
            this.filtros.tipoFechaAceptacion = 0;
            this.filtros.fechaInicio = null;
            this.filtros.fechaFin = null;
          }
          this.fields[2].valor = null;
          // this.filtros.tipoFiltroClasifacion = 0;
        }
      }
      this.loader = true;
      this.datosTabla = [];
      this.$http.post(this.$api + "pdfImpresionPTI/fotoPti", this.filtros).then(respuesta => {
        this.datosTabla = respuesta.data.data;
      })
          .catch((error) => {
            console.error(error);
          }).finally(() => {
        this.loader = false;
      });
    },
    validateState(name){
      const {$dirty, $error} = this.$v.cfdi[name];
      return $dirty ? !$error : null;
    },
    cerrarModal(tipo) {
      this.modalFiltros = false;
      if (tipo === 1) {
        this.eliminarFiltro();
      }
    },
    eliminarFiltro() {
      this.indexFiltro = null;
      this.idPaciente = 0;
      this.nombrePacienteFiltro = "";
      this.tipoFiltro = 0;
      this.tipoFlujoFiltro = 0;
      this.nombreDoctorFiltro = "";
      this.numeroSillonFiltro = 0;
      this.tipoHorario = 0;
      this.horaInicioFiltro = [];
      this.horaFinFiltro = [];
      this.traerCitasActivasCaja();
    },
    cerrarModalPrevia(){
      this.mostrarDescarga = false;
      this.documento = {
        "idDoumentacionLegal": null,
        "documentacion": null,
        "rutaDocumentacion": null,
        "tipoDocumentoLegalDTO": null,
        "imagenBase64":null,
        "registro":null
      }
    },
    descargar(item) {
      this.mostrarDescarga(true);
      this.base64Archivo = item.imagenBase64;

      this.$nextTick(() => {
        this.$v.$reset()
      });
    },
    obtenerRecibos() {
      this.loaderPDF = true;
      this.datosTablaRecibo = [];
      this.$http
          .post(
              this.$api + "fiscales/obtener/recibos", this.idPaciente, { 'headers': { 'Authorization': this.headers}}
          )
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.datosTablaRecibo = [];
              respuesta.data.data
                  .filter(
                      (r) =>
                          r.facturado === false && r.activo === true && r.montopagado > 0
                  )
                  .map((it) => {
                    it.loaderPDF = false;
                    this.datosTablaRecibo.push(it);
                  });
            }
          })
          .finally(() => {
            this.loaderPDF = false;
          });
    },
    enviarCorreo(idFotoPti){
      this.loaderPDF= true;
      this.$http.get(this.$api + "pdfImpresionPTI/enviarCorreo?idFotoPti="+ idFotoPti.idFotoPti + "&idPaciente=" +this.propidPaciente).then((r) => {
        if ( r.data.data){
          this.$swal({
            icon: "success",
            text: "Correo enviado exitosamente",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });

        }else {
          this.$swal({
            icon: "warning",
            text:
                "No existe correo registrado",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
        }

      }).catch((error) => {
        this.$swal({
          icon: "error",
          text:
              "Ups, algo salio mal",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });

        console.error(error);
      }).finally(() => {
        this.loaderPDF = false;
        this.loaderOcupacion = false;
      });
    },
    async descargarAchivo(archivo) {
      console.log("archivo",archivo)
      await this.validarTokenAWS();
      let config = {
        region: this.token.regionBucket,
        credentials: {
          accessKeyId: this.token.accessKeyId,
          secretAccessKey: this.token.secretAccessKey,
          sessionToken: this.token.sessionToken,
        },
      }
      try{
        const client = new S3Client(config);
        const input = {
          Bucket: this.token.nombreBucket,
          Key: archivo.urlFoto,
        };
        const command = new GetObjectCommand(input);
        const response = await client.send(command);
        const responseS3 = await new Response(response.Body);
        const imageBlob = await responseS3.blob();
        const reader = await new FileReader();
        reader.onloadend = () => {
          this.downloadBase64File(
              "application/pdf",
              reader.result.split(',')[1],
              archivo.nombreArchivo
          );
        }
        reader.onerror = error => {
          console.error(error);
        }
        reader.readAsDataURL(imageBlob)
      }catch (caught) {
        if (caught instanceof NoSuchKey) {
          console.error(
              `Error from S3 while getting object "${archivo.urlFoto.split('/')[1]}" from "${this.token.nombreBucket}". No such key exists.`,
          );
        } else if (caught instanceof S3ServiceException) {
          console.error(
              `Error from S3 while getting object from ${this.token.nombreBucket}.  ${caught.name}: ${caught.message}`,
          );
        } else {
          throw caught;
        }
      }
    },
    downloadBase64File(contentType, base64Data, fileName) {
      const linkSource = `data:${contentType};base64,${base64Data}`;
      const downloadLink = document.createElement("a");
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
      this.loaderDescargar = false;
      this.$swal.fire({
        icon: "info",
        title: "Aviso",
        text: "Se descargo el archivo correctamente",
      });
    },
  }
}
</script>

<style>

 .b-form-btn-label-control.form-control > .form-control {
   font-size: 12px !important;
 }

.select-options li {
  padding: 10px;
  cursor: pointer;
}

.select-options li:hover {
  background-color: #f2f2f2;
  color: black;
}

.mx-datepicker-range {
  width: 218px !important;
}
.mx-input {
  border: 0 !important;
  font-weight: 600;
  font-size: 12px;
}
 ::placeholder {
   color: black;
   font-size: 12px;
 }
</style>
